export enum MouseEvents {
  MouseEnter = 'mouseenter',
  MouseLeave = 'mouseleave',
  Click = 'click'
}
